import React from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { Section } from "./Section";

export default function EditorialEssay() {
  const { d } = useI18n();
  const [first, ...rest] = d.essay.paragraphs;

  return (
    <Section testid="editorial-essay">
      <div className="max-w-4xl mx-auto">
        <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-jlo-gold font-semibold mb-5 text-center">
          {d.essay.kicker}
        </p>
        <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-jlo-warm text-center leading-tight">
          {d.essay.heading}
        </h2>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mt-12"
        >
          <p className="text-lg text-jlo-warm/85 leading-relaxed first-letter:font-display first-letter:text-6xl first-letter:font-bold first-letter:text-jlo-gold first-letter:float-left first-letter:mr-3 first-letter:leading-[0.8]">
            {first}
          </p>

          <blockquote className="my-10 border-l-2 border-jlo-gold pl-6 py-2">
            <p className="font-display text-2xl sm:text-3xl italic text-jlo-gold/90 leading-snug">
              “{d.essay.pullQuote}”
            </p>
          </blockquote>

          <div className="columns-1 md:columns-2 gap-10 [&>p]:mb-5">
            {rest.map((para, i) => (
              <p key={i} className="text-base text-jlo-warm/75 leading-relaxed break-inside-avoid">
                {para}
              </p>
            ))}
          </div>
        </motion.div>
      </div>
    </Section>
  );
}
